/**
 * Delivery Partner Master Data Interfaces
 * Framework-agnostic TypeScript interfaces for Delivery Partner management
 */

export interface DeliveryPartner {
  id: number;
  name: string;
  description: string;
  program_id: number;
  status?: number;
  created_at?: string;
  updated_at?: string;
}

export interface DeliveryPartnerFormData {
  name: string;
  description: string;
  program_id: number;
  id?: number;
}

export interface DeliveryPartnerApiResponse {
  status: number;
  data: {
    data: DeliveryPartner[];
  };
  body?: {
    data: {
      message?: string;
    };
  };
}
